import React, { Component, Fragment } from 'react';
import { cloneDeep } from 'lodash';
import {Col, Form, Input, message, Modal, Row, Select, Table,  Tooltip, Button} from 'antd';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';
import moment from "moment-jalaali";
import {Constants} from "../scripts/settings";
import API from "../scripts/api";
import {
    CloseCircleFilled,
    DeleteOutlined,
    EditOutlined,
    EyeOutlined,
    SearchOutlined,
    PrinterOutlined,
  } from "@ant-design/icons";
class BarcodeReportForm extends Component {
    constructor() {
        super();

        this.data = [];
        this.state = {
            productBarcodes: [],
            filterParams: {},
            selected: {},
             pagination: {
                    total: 0,
                    current: 1,
                    pageSize: Constants.pageSize,
                    size: "small",
                  },
        };


        this.formRef = React.createRef();
    }

    handleSubmit = () => {
        // this.formRef.current.validateFields().then(values => {
        //     this.props.onSubmit(values);
        // });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();
    }

    handleDidMount = async (data = {}, filterParams) => {
        console.log("data is: ", data )
        this.setState({filterParams: filterParams, selected: data, productBarcodes: []})

        await this.getProductBarcodes(data, filterParams)
        // const cloneData = cloneDeep(data);
    }

     getProductBarcodes = async (val = {}, params) => {
       
    
        return API.BarcodeReports
          .productUsedBarcodes(val.id, params)
          .then((result) => {
             this.setState({
                productBarcodes: result.data.data,
                pagination: {
                    ...this.state.pagination,
                    ...{
                      current: result.data.current_page,
                      pageSize: result.data.per_page,
                      total: result.data.total,
                    },
                  },
             })
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      };

      handleTableChange = async (pagination) => {
        let {filterParams} = this.state
        filterParams.page = pagination.current
        await this.getProductBarcodes(this.state.selected, filterParams);
      };


      handleDelete = (id) => {
        Modal.confirm({
          title: Resources.confirmDeleteOffer,
          okText: Resources.yes,
          okType: "danger",
          cancelText: Resources.no,
          onOk: () => {
            this.setState({ loading: true });
    
            API.BarcodeReports
              .delete(id)
              .then(async (result) => {
                message.success(result.message);
                let {filterParams} = this.state
                filterParams.page = this.state.pagination.current
                await this.getProductBarcodes(this.state.selected, filterParams);
                // this.fetch({ page: this.state.pagination.current });
              })
              .catch(() => {
                this.setState({ loading: false });
              });
          },
        });
      };
    render() {
        const { onCancel, submitting, visible } = this.props;
        const { editMode, productBarcodes, pagination } = this.state;
        const columns = [
            {
                title: Resources.barcode,
                dataIndex: "barcode",
                width: "30px",
            },
            {
                title: Resources.registrar,
                dataIndex: "user",
                width: "30px",
                render: (val) => val?.name+ " "+ val?.family,
            },
            {
                title: Resources.buyer,
                dataIndex: "cart",
                width: "30px",
                render: (val) => val?.user?.name+ " "+ val?.user?.family,
            },
            {
                title: Resources.buyer_mobile,
                dataIndex: "cart",
                width: "30px",
                render: (val) => val?.user?.phone,
            },


            {
                title: Resources.count,
                dataIndex: "print_barcode",
                width: "30px",
                render: (val) => val?.package_count,
            },

            {
                title: Resources.row,
                dataIndex: "row",
                width: "30px",
                render: (val) => val?.title,
            },
            {
                title: Resources.identifier,
                dataIndex: "identifier",
                width: "30px",
                render: (val) => val?.title,
            },
            {
                title: Resources.shelf,
                dataIndex: "shelf",
                width: "30px",
                render: (val) => val?.title,
            },
            {
                title: Resources.dateAndTime,
                dataIndex: "cart_product",
                width: "30px",
                render: (val) => (val) ? moment(val.created_at).format(Constants.jDateTimeFormat) : "",
            },
            {
                title: Resources.type,
                dataIndex: "is_scan",
                width: "30px",
                render: (val) => (val == "1") ? <span style={{color:"blue"}}  >{Resources.scanned}</span>:  <span style={{color:"red"}}  >{Resources.deleted}</span>,
            },
            {
                title: Resources.action,
                dataIndex: "id",
                className: "col-center",
                width: "120px",
                render: (val, record) => (
                  <Fragment>
                      <Tooltip title={Resources.delete}>
                        <Button
                          type="link"
                          style={{color: "red"}}
                          icon={<DeleteOutlined />}
                          onClick={() => this.handleDelete(val)}
                        />
                      </Tooltip>
                  </Fragment>
                ),
              }

        ];
        console.log("visible is : ", visible)


        return (
            <Modal
                title={Resources.report}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={1400}>
                <Form  >
                    <div>
                        <Table
                            columns={columns}
                            dataSource={productBarcodes}
                            loading={submitting}
                            onChange={this.handleTableChange}
                            // pagination={false}
                            pagination={pagination}

                            size="small"
                            rowKey="id"
                            scroll={{ x: 1000 }}
                        />
                    </div>
                </Form>
            </Modal>
        );
    }
};

export default BarcodeReportForm;